<template lang="pug">
.conteudo
    .linha(style='margin: 0px')
        .coluna
            title-component(:label='$route.meta.titulo')

    .linha(style='margintop: 0px')
        .coluna
            breadcrumb-component(:list='breadcrumb')

    .linha
        .coluna
            filtro-component(
                v-if='filtroCarregado'
                :municipios='municipios',
                :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                @filtro:pesquisar='pesquisar($event, false)',
                @filtro:limpar='limpar',
            )

    .linha(style='justify-content: flex-end', v-if='isUsuarioSemil()')
        button-component(label='Áreas a recompor', icon='mdi-download', @click.native='modalEmail = true' style='margin-right: 15px')
        button-component(label='Exportar Relatório', icon='mdi-download', @click.native='baixarRelatorio' style='margin-right: 10px')
    .linha(style='paddingtop: 20px')
        b.coluna Listagem de processos

    .linha
        .coluna
            caixa-entrada-table-component(
                :headers='headersFiltrados',
                :data='paginacao.processos',
                :paginacao='paginacao',
                :is-loading='isLoading',
                :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                @inbox:page-change='checkPaginationChange($event)',
                @inbox:pagination='getPagination($event)'
            )
    ModalComponent(
        v-if='modalEmail'
        title='Exportar Relatório por email'
        width='500px'
        @close='modalEmail = false'
    )
        p.text O relatório será gerado e ao término do processamento será enviado por email.
        span.text Digite o email para envio do relatório:
        text-input-component(v-model='email', placeholder='Digite o e-mail')
        el-divider
        .button-relatorio
            button-component(label='Gerar Relatório', icon='mdi-check', @click.native='gerarRelatorioAreasRecompor')
</template>

<script>
import {
    listar,
    listarMunicipiosDisponiveis,
    listarPageValidacaoProposta,
    listarPageCaixaEntradaGO,
    listarPageTermoCompromisso,
    listarPageConsultarProcessos,
    listarPageReanalise,
    exportarRelatorio,
    gerarRelatorioAreasRecompor
} from '@/services/processo.service';

import FiltroComponent from '@/components/standard/FiltroComponent.vue';
import ButtonComponent from '@/components/standard/ButtonComponent.vue';
import {
    caixaEntradaGO,
    validacaoAnaliseGO,
    analiseProposta,
    termoCompromisso,
    consultarProcessos,
    reanaliseProposta,
    analiseHistorico,
} from '@/utils/breadcrumb.utils';
import CaixaEntradaTableComponent from '@/views/caixaEntrada/components/CaixaEntradaTable.vue';
import { Perfil } from '@/utils/constants.utils.js';
import ModalComponent from '@/components/design/ModalComponent.vue';

export default {
    name: 'CaixaEntradaComponent',
    components: {
        ButtonComponent,
        FiltroComponent,
        CaixaEntradaTableComponent,
        ModalComponent,
    },
    data() {
        return {
            headers: [
                {
                    text: '',
                    field: 'processoSelecionado',
                    maxWidth: '',
                },
                {
                    text: '',
                    field: 'statusImovel',
                    maxWidth: '',
                },
                {
                    text: 'CAR',
                    field: 'codigoImovel',
                    maxWidth: '',
                },
                {
                    text: '',
                    field: 'copiarCodigoImovel',
                    maxWidth: '',
                },
                {
                    text: 'Município',
                    field: 'municipio',
                    maxWidth: '',
                },
                {
                    text: 'Envio da proposta',
                    field: 'dataEnvioProposta',
                    maxWidth: '',
                },
                {
                    text: 'Área a compensar (ha)',
                    field: 'areaTotalCompensar',
                    maxWidth: '70px',
                    tooltip: 'Área compensar (ha)',
                },
                {
                    text: 'Área a recompor (ha)',
                    field: 'areaTotalRecompor',
                    maxWidth: '70px',
                    tooltip: 'Área recompor (ha)',
                },
                {
                    text: 'Fase do processo',
                    field: 'condicaoInscricao',
                    maxWidth: '',
                },
                {
                    text: 'Data da assinatura do TC',
                    field: 'dataAsinaturaTC',
                    maxWidth: ''
                },
                {
                    text: 'Vinculação',
                    field: 'dataVinculoTecnico',
                    maxWidth: '',
                },
                {
                    text: 'Condição',
                    field: 'condicao',
                    maxWidth: '',
                },
                {
                    text: 'Devolutiva',
                    field: 'devolutiva',
                    maxWidth: '',
                },
                {
                    text: 'Ações',
                    sortable: false,
                    field: 'acao',
                    maxWidth: '',
                },
            ],
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            },
            filtro: {},
            municipios: [],
            isLoading: false,
            mostrarFaseProcesso: false,
            filtroCarregado: false,
            listagemProcessosMap: {
                'Validação da Proposta': listarPageValidacaoProposta,
                'Caixa de entrada': listarPageCaixaEntradaGO,
                'Termo de Compromisso': listarPageTermoCompromisso,
                'Consultar processos': listarPageConsultarProcessos,
                'Em Reanálise': listarPageReanalise,
                'Análise da Proposta': listar,
            },
            breadcrumbMap: {
                'Validação da Proposta': validacaoAnaliseGO,
                'Caixa de entrada': caixaEntradaGO,
                'Termo de Compromisso': termoCompromisso,
                'Consultar processos': consultarProcessos,
                'Em Reanálise': reanaliseProposta,
                'Análise da Proposta': analiseProposta,
                'Historico da Análise': analiseHistorico,
            },
            usuario: this.$eu(),
            modalEmail: false,
            email: null,
        };
    },

    async created() {
        this.isLoading = true;
        this.municipios = await listarMunicipiosDisponiveis();
        this.isLoading = false;
        this.filtroCarregado = true;
        const usuario = this.$eu();
       
        const nomeColuna = this.isUsuarioSemil() ? 'dataVinculoTecnico' : 'dataAsinaturaTC';
        this.headers = this.headers.filter(header => header.field !== nomeColuna);
    },
    computed: {
        breadcrumb() {
            const paginaAtual = this.$route.meta.titulo;
            return this.breadcrumbMap[paginaAtual];
        },
        mostrarFaseProcessoFiltro() {
            return this.$route.meta.mostrarFaseProcesso;
        },
        headersFiltrados() {
            return this.headers.filter((header) => {
                const paginaAtual = this.$route.meta.titulo;
                if (header.field === 'condicaoInscricao' || header.field === 'processoSelecionado') {
                    return this.mostrarFaseProcessoFiltro;
                }
                if (header.field === 'dataVinculoTecnico') {
                    return !this.mostrarFaseProcessoFiltro;
                }
                if (header.field === 'devolutiva') {
                    return paginaAtual === 'Termo de Compromisso';
                }
                return true; // Exibe o header "Vinculação" independentemente
            });
        },
    },

    methods: {
        async pesquisar(filtro) {
            this.filtro = filtro;
            this.isLoading = true;

            this.paginacao.processos = [];

            const paginaAtual = this.$route.meta.titulo;
            const listarProcessos = this.listagemProcessosMap[paginaAtual];
            this.paginacao = await listarProcessos(filtro);
            this.paginacao.processos = this.paginacao.processos.map((item) => ({
                ...item,
                selecionado: false,
            }));

            this.isLoading = false;
        },

        limpar() {
            const limpo = {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            };
            this.pesquisar(limpo);
        },

        checkPaginationChange(page) {
            this.pesquisar({
                ...this.filtro,
                pagina: page,
            });
        },

        getPagination(paginationEvent) {
            return paginationEvent;
        },
        async baixarRelatorio() {
            try {
                const blob = await exportarRelatorio(this.filtro);

                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Relatório.xlsx'); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                this.$notify({
                    title: 'Erro',
                    message: 'Não foi possível exportar o relatório.',
                    type: 'error',
                });
            }
        },
        isUsuarioSemil() {
           return this.usuario.perfil === Perfil.SEMIL;
        }, 
        async gerarRelatorioAreasRecompor() {
            this.$emit('update-loading', true);
            if (!this.email) {
                this.$notify({
                    title: 'Atenção',
                    message: 'É necessário informar um e-mail para envio do relatório.',
                    type: 'warning',
                });
                return;
            }
            this.modalEmail = false;
            const email = this.email;
            this.email = null;
            gerarRelatorioAreasRecompor(this.filtro, email);
        },
    },
};
</script>

<style lang="scss" scoped>
.paginacao {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.button-relatorio {
    display: flex;
    justify-content: center;
    justify-items: center;
}

.text {
    color: #35373b;
    padding: 10px 0px;
    font-size: 13px;
}
</style>
